import React, { Fragment } from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { theme } from '../../../styled'
import { DownloadAttackValueLink } from './download-attack-value-link'

interface Props {
  readonly organizationID: string
  readonly eventUuid: string
  readonly attackValue?: string
  readonly truncatedValue?: boolean
}

export const AttackTypeTooltip: React.FC<Props> = ({
  organizationID,
  eventUuid,
  attackValue,
  truncatedValue = false
}) => {
  return (
    <Fragment>
      <div
        className={css`
          max-width: 325px;
          word-break: break-word;
          color: ${theme.colors.white};
        `}
      >
        <FormattedMessage
          id="placeholder_value"
          children={(message) => (
            <span
              className={css`
                padding-right: 3px;
                font-weight: ${theme.fontWeights.primary.bold};
              `}
            >
              {`${message}:`}
            </span>
          )}
        />
        {`${attackValue}${truncatedValue ? '...' : ''}`}
      </div>
      {truncatedValue && (
        <DownloadAttackValueLink
          organizationID={organizationID}
          eventUuid={eventUuid}
        />
      )}
    </Fragment>
  )
}
